import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { InterventionContentItem } from '../../../models/intervention-content-item';
import { InterventionContentItemOrder } from '../../../models/intervention-content-item-order';

export const getInterventionContentItemsSuccess = createAction(
  '[Intervention Content Items] Get Intervention Content Items Success',
  props<{ interventionContentItems: InterventionContentItem[] }>()
);

export const getInterventionContentItemsError = createAction(
  '[Intervention Module] Get Intervention Modules Error',
  props<{ err: HttpErrorResponse }>()
);

export const addContentItemToIntervention = createAction(
  '[Intervention Content Item] Add Content Item to Intervention',
  props<{
    studyId: number;
    interventionId: number;
    itemId: number;
    itemType: string;
  }>()
);

export const addContentItemToInterventionSuccess = createAction(
  '[Intervention Content Item] Add Content Item to Intervention Success',
  props<{ studyId: number; interventionId: number; interventionContentItem: InterventionContentItem }>()
);

export const addContentItemToInterventionError = createAction(
  '[Intervention Content Item] Add Content Item to Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const removeContentItemFromIntervention = createAction(
  '[Intervention Content Item] Remove Content Item From Intervention',
  props<{
    studyId: number;
    interventionId: number;
    itemId: number;
    itemType: string;
    interventionContentItemId: number;
  }>()
);

export const removeContentItemFromInterventionSuccess = createAction(
  '[Intervention Content Item] Remove Content Item From Intervention Success',
  props<{ studyId: number; interventionId: number; deletedItemId: number; deletedItemType: string }>()
);

export const removeContentItemFromInterventionError = createAction(
  '[Intervention Content Item] Remove Content Item From Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const saveContentItemsSortingOrder = createAction(
  '[Intervention Content Item] Save Content Item Sorting Order',
  props<{
    studyId: number;
    interventionId: number;
    sortingOrder: InterventionContentItem[];
  }>()
);

export const saveContentItemsSortingOrderSuccess = createAction(
  '[Intervention Content Item] Save Content Item Sorting Order Success',
  props<{ newSortingOrder: InterventionContentItemOrder[] }>()
);

export const saveContentItemsSortingOrderError = createAction(
  '[Intervention Content Item] Save Content Item Sorting Order Error',
  props<{ err: HttpErrorResponse }>()
);

export const addTimingRuleToContentItem = createAction(
  '[Intervention Content Item] Add Timing Rule To Content Item',
  props<{ updatedContentItem: InterventionContentItem }>()
);
